function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,160.000000) scale(0.100000,-0.100000)",
  fill: "#288b94",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M432 1367 c-20 -21 -22 -34 -22 -155 l0 -132 -125 0 c-120 0 -127 -1 -150 -25 l-25 -24 0 -259 c0 -322 -12 -300 170 -304 l125 -3 5 -59 c9 -99 -3 -96 370 -96 374 0 361 -4 368 99 l4 61 128 0 c183 0 172 -20 168 313 -4 320 10 297 -174 297 l-124 0 0 129 c0 115 -2 131 -21 155 l-20 26 -328 0 -328 0 -21 -23z m652 -23 c13 -5 16 -27 16 -135 l0 -129 -325 0 -325 0 0 123 c0 82 4 127 12 135 9 9 91 12 309 12 164 0 304 -3 313 -6z m305 -318 c8 -9 11 -87 9 -262 l-3 -249 -122 -3 -123 -3 0 121 0 120 25 0 c18 0 25 5 25 20 0 20 -7 20 -425 20 -418 0 -425 0 -425 -20 0 -16 7 -20 30 -20 l30 0 0 -120 0 -120 -118 0 c-78 0 -122 4 -130 12 -9 9 -12 78 -12 249 0 203 2 240 16 253 14 14 83 16 613 16 495 0 601 -2 610 -14z m-289 -464 c0 -133 -4 -192 -12 -200 -9 -9 -91 -12 -309 -12 -257 0 -300 2 -313 16 -13 13 -16 46 -16 200 l0 184 325 0 325 0 0 -188z",
  fill: "#288b94"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1110 970 c0 -19 7 -20 100 -20 93 0 100 1 100 20 0 19 -7 20 -100 20 -93 0 -100 -1 -100 -20z",
  fill: "#288b94"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530 680 c0 -19 7 -20 250 -20 243 0 250 1 250 20 0 19 -7 20 -250 20 -243 0 -250 -1 -250 -20z",
  fill: "#288b94"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530 575 l0 -25 250 0 250 0 0 25 0 25 -250 0 -250 0 0 -25z",
  fill: "#288b94"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530 475 l0 -25 250 0 250 0 0 25 0 25 -250 0 -250 0 0 -25z",
  fill: "#288b94"
}));

var SvgLogoListaAImprimibles = function SvgLogoListaAImprimibles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "156.000000pt",
    height: "160.000000pt",
    viewBox: "0 0 156.000000 160.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoListaAImprimibles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoListaAImprimibles.a229011f.svg";
export { ForwardRef as ReactComponent };